import { gql } from '@apollo/client';

export const CREATE_MITARBEITER = gql`
  mutation createMitarbeiter(
    $standortId: String!
    $input: mitarbeiter_mitarbeiterCreateInput!
  ) {
    mitarbeiter_mitarbeiterCreate(standortId: $standortId, input: $input) {
      success {
        ... on mitarbeiter_MitarbeiterCreateSuccess {
          mitarbeiter {
            id
          }
          fristenResult {
            result {
              success {
                ... on mitarbeiter_Frist {
                  id
                }
              }
              failure {
                ... on mitarbeiter_ManagerNotFoundError {
                  managerIds
                  message
                }
                ... on mitarbeiter_MitarbeiterNotFound {
                  mitarbeiterId
                  message
                }
                ... on mitarbeiter_FristenErinnerungNachFristDatum {
                  invalidErinnernAm
                  message
                }
                ... on mitarbeiter_MitarbeiterAbstractError {
                  message
                }
              }
            }
            generalError {
              message
            }
          }
          personalzugang {
            success
            error {
              errorCode
              message
            }
          }
        }
      }
      validationErrors {
        errorCode
        message
      }
      error {
        __typename
        message
      }
    }
  }
`;
